module.exports = __webpack_public_path__ + "static/img/cert4.8b602f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutpic/cert4.png
// module id = R5xB
// module chunks = 52